export default {
    meta: {
        title: '推荐结果',
        url: '/shoprecommend',
        urlName: '开店区域推荐' // 埋点字段，上报归属的模块
    }
};
